// Full Circle listing
export const GET_FULL_CIRCLE_LIST = "GET_FULL_CIRCLE_LIST";
export const GET_FULL_CIRCLE_LIST_SUCCESS = "GET_FULL_CIRCLE_LIST_SUCCESS";
export const GET_FULL_CIRCLE_LIST_ERROR = "GET_FULL_CIRCLE_LIST_ERROR";
export const SET_FULL_CIRCLE_PAGE = "SET_FULL_CIRCLE_PAGE";

// Add full circle content
export const ADD_FULL_CIRCLE = "ADD_FULL_CIRCLE";
export const ADD_FULL_CIRCLE_SUCCESS = "ADD_FULL_CIRCLE_SUCCESS";
export const ADD_FULL_CIRCLE_ERROR = "ADD_FULL_CIRCLE_ERROR";

// Edit full circle content
export const EDIT_FULL_CIRCLE = "EDIT_FULL_CIRCLE";
export const EDIT_FULL_CIRCLE_SUCCESS = "EDIT_FULL_CIRCLE_SUCCESS";
export const EDIT_FULL_CIRCLE_ERROR = "EDIT_FULL_CIRCLE_ERROR";

// Delete full circle content
export const DELETE_FULL_CIRCLE = "DELETE_FULL_CIRCLE";
export const DELETE_FULL_CIRCLE_SUCCESS = "DELETE_FULL_CIRCLE_SUCCESS";
export const DELETE_FULL_CIRCLE_ERROR = "DELETE_FULL_CIRCLE_ERROR";

// Schedule call
export const SCHEDULE_CALL = "SCHEDULE_CALL";
export const SCHEDULE_CALL_SUCCESS = "SCHEDULE_CALL_SUCCESS";
export const SCHEDULE_CALL_ERROR = "SCHEDULE_CALL_ERROR";

// Interview folders
export const GET_INTERVIEW_FOLDERS = "GET_INTERVIEW_FOLDERS";
export const GET_INTERVIEW_FOLDERS_SUCCESS = "GET_INTERVIEW_FOLDERS_SUCCESS";
export const GET_INTERVIEW_FOLDERS_ERROR = "GET_INTERVIEW_FOLDERS_ERROR";
export const ADD_INTERVIEW_FOLDER = "ADD_INTERVIEW_FOLDER";
export const ADD_INTERVIEW_FOLDER_SUCCESS = "ADD_INTERVIEW_FOLDER_SUCCESS";
export const ADD_INTERVIEW_FOLDER_ERROR = "ADD_INTERVIEW_FOLDER_ERROR";
export const EDIT_INTERVIEW_FOLDER = "EDIT_INTERVIEW_FOLDER";
export const EDIT_INTERVIEW_FOLDER_SUCCESS = "EDIT_INTERVIEW_FOLDER_SUCCESS";
export const EDIT_INTERVIEW_FOLDER_ERROR = "EDIT_INTERVIEW_FOLDER_ERROR";
export const DELETE_INTERVIEW_FOLDER = "DELETE_INTERVIEW_FOLDER";
export const DELETE_INTERVIEW_FOLDER_SUCCESS = "DELETE_INTERVIEW_FOLDER_SUCCESS";
export const DELETE_INTERVIEW_FOLDER_ERROR = "DELETE_INTERVIEW_FOLDER_ERROR";
export const SET_INTERVIEW_FOLDERS = "SET_INTERVIEW_FOLDERS";
export const SET_FULL_CIRCLE_LIST = "SET_FULL_CIRCLE_LIST";
